import WasmController from "react-lib/frameworks/WasmController";
import preflightM from "issara-sdk/apis/preflightM";
import RequestToken from "issara-sdk/apis/RequestTokenAPI_users";
import GetProviderInfo from "issara-sdk/apis/GetProviderInfo_apps_HRM";
import DivisionHasUserList from "issara-sdk/apis/DivisionHasUserList_apps_PRX";
import DeviceList from "issara-sdk/apis/DeviceList_core";
import RoleList from "issara-sdk/apis/RoleList_users";
import ScreenListView from "issara-sdk/apis/ScreenListView_users";
import GetCurrentDoctorView from "issara-sdk/apis/GetCurrentDoctorView_core";
import MyPositionDetail from "issara-sdk/apis/MyPositionDetail_users";
import MyPermissionView from "issara-sdk/apis/MyPermissionView_users";
import DivisionList from "issara-sdk/apis/DivisionList_core";
import DivisionHasUserListForOtherUser from "issara-sdk/apis/DivisionHasUserListForOtherUser_apps_PRX";
import OfficialAccountDetailWithDivision from "issara-sdk/apis/OfficialAccountDetailWithDivision_apps_PRX";
import UserEmployeeDetailAPIView from "issara-sdk/apis/UserEmployeeDetailAPIView_users";
import UserDetailAPIView from "issara-sdk/apis/UserDetailAPIView_users";
import ConstanceView from "issara-sdk/apis/ConstanceView_core";
import MenuHasVideoListView from "issara-sdk/apis/MenuHasVideoListView_users";

import { Mode } from "../Model";
import * as CONSTANT from "react-lib/utils/constant";
import CONFIG from "config/config";
import Cookies from "js-cookie";
import DivisionDetail from "issara-sdk/apis/DivisionDetail_core";

import axios from "axios";
import { getSideMenuIndex, mapOptions } from "../CommonInterface";
import { getDeviceIdAndUserSubScription, getBrowserName, getOSName } from "./GetUserSubScription";
import { AdminMenuListKey, ADMIN_MENU_LIST } from "../../HRM/HRMInterface";
import { onAuthStateChanged, signInWithCustomToken, signOut } from "firebase/auth";
import { httpsCallable } from "firebase/functions";

export type Props = {

}

export type State = {
  django?: any;
  isDoctor?: boolean;
  isNurse?: boolean;
  providerInfo?: any;
  providerEmployeeInfo?: any;
  userRoleList?: any;
  divisionType?: string | null;
  divisionList?: any[];
  divisionOptions?: any[];
  divisionHasUserItems?: any[];
  selectedDivision?: any;
  deviceOptions?: any[];
  selectedDevice?: any;
  showMenuNoti?: boolean;
  openVideoCallModal?: boolean;
  closeOverriding?: boolean;
  videoCallRoom?: string;
  currChatChannelId?: string;

  loggedin?: boolean;
  currentDoctor?: any;
  userPosition?: any;
  myPermission?: any;
  // offline Mode
  isOffline?: boolean;

  AppInitializeSequence?: {
    sequenceIndex: string | null;
    username?: string;
    password?: string;
  } | null;

  mode?: Mode;
  resetLayout?: boolean;
  openPassword?: boolean;
  loadingLogin?: boolean;
  errorMessage?: null;
  initialLayout?: number;

  userId?: string;
  // From CU
  showColorInfo?: boolean;
  showTabName: string;

  // Language
  userSelectedLanguage?: "en" | "th";

  adminMenuDivisions?: AdminMenuDivisionType;

  loginWithSocial: "facebook" | "google" | "line" | null;
  userProfile?: Record<string, any>;

  menuHasVideos?: any[];
  officialAccountDetail?: Record<string, any>;
};

type AdminMenuDivisionType = Record<
  string,
  Partial<
    Record<
      AdminMenuListKey,
      { divisions: Record<string, any>[]; ids: Record<number, number>; tabs: string[]; }
    >
  >
>;

export const StateInitial: State = {
  django: {},
  isDoctor: false,
  isNurse: false,
  providerInfo: null,
  providerEmployeeInfo: null,
  userRoleList: [],
  divisionType: null,
  divisionList: [],
  divisionOptions: [],
  divisionHasUserItems: [],
  selectedDivision: null,
  deviceOptions: [],
  selectedDevice: null,
  showMenuNoti: false,

  loggedin: false,
  currentDoctor: null,
  userPosition: null,
  myPermission: null,

  isOffline: false,

  AppInitializeSequence: null,

  loginWithSocial: Cookies.get("loginWithSocial"),
  mode: Cookies.get("loginWithSocial") ? "admin" : "patient",
  resetLayout: false,
  openPassword: false,
  loadingLogin: false,
  errorMessage: null,
  initialLayout: 0,

  userId: Cookies.get("user_id"),
  userSelectedLanguage:
    ((Cookies.get("user_lang") || window.navigator?.language?.split("-")?.[0]) as "en" | "th") ||
    "en",
  showColorInfo: false,
  showTabName: "",
  adminMenuDivisions: {},
};

export type Event = { message: "RunSequence"; params: {} };

export type Data = {
  division?: number;
  divisionHasUser?: any[];
  divisionDict?: any;
  allDivisionList?: any[];
  allDivisionDict?: any;
  allDivisionGroup: any[];
  divisionDetail?: any;
  device?: number;
  deviceDict?: any;
  user?: number;
  provider?: number;
  userProfile?: Record<string, any>;
  constanceConfig?: Record<string, any>;
};

export const DataInitial = {
  division: 0,
  divisionHasUser: [],
  divisionDict: {},
  allDivisionList: [],
  allDivisionDict: {},
  divisionDetail: {},
  device: 0,
  deviceDict: {},
  userProfile: {},
  constanceConfig: {},
};

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;


export const clearLoginSession: Handler = (controller, params) => {

  controller.apiToken = "";
  if (controller.auth) {
    signOut(controller.auth)
  }

  Cookies.set("apiToken", "");
  Cookies.set("division_id", "");
  Cookies.set("device_id", "");
  Cookies.set("user_id", "");
  Cookies.set("offlineMode", "online");
  Cookies.set("loginWithSocial", "");

  const currentFilter = Cookies.get("filterDrugOrderQueue");

  if (currentFilter) {
    const filter = JSON.parse(currentFilter);

    // บันทึก Cookie ใหม่ที่มีเฉพาะ selectedSort
    Cookies.set("filterDrugOrderQueue", JSON.stringify({ selectedSort: filter.selectedSort }));
  }

  controller.data.provider = 0;
}

export const First: Handler = async (controller, params) => {
  console.log('App Initialize First params:', params);
  const state = controller.getState();
  if (!state.AppInitializeSequence) return;

  // Go to Login if no apitoken TEST current APIToken
  if (controller.apiToken) {
    const [r, e, n] = await preflightM.get({
      apiToken: controller.apiToken,
    })
    if (n?.response?.status === 401 && e) {
      clearLoginSession(controller, params)
    }
  }

  const apiToken = controller.apiToken;

  if (typeof apiToken === "undefined" || apiToken === null || apiToken === "") {
    console.log("not logged in");
    return controller.setState({
      AppInitializeSequence: {
        ...state.AppInitializeSequence,
        sequenceIndex: "Login",
        username: "",
        password: "",
      },
    });
  }

  console.log("Already login");
  // User already login on load, go straight to Greeting
  controller.setState(
    {
      AppInitializeSequence: {
        ...state.AppInitializeSequence,
        sequenceIndex: "GetUserInfo",
      },
    },
    () => controller.handleEvent({ message: "RunSequence", params: params })
  );
  return;
};

export const Login: Handler = async (controller, params) => {
  const state = controller.getState();
  controller.setState({
    loadingLogin: true,
  });
  if (!state.AppInitializeSequence) return;
  if (params?.action === "LoginSubmit") {
    console.log("called getFingerPrintAndSubscription");

    const [deviceId, userSubscription] = await getDeviceIdAndUserSubScription(params.type === "email");
    console.log("userSubscription: ", userSubscription);
    console.log("deviceId: ", deviceId);

    // let deviceId = ""
    // let userSubscription = null;
    // if (config.BYPASS_SERVICE_WORKER) {
    //   // ไม่มี Service worker
    //   const options = {};
    //   let components = await Fingerprint2.getPromise(options);
    //   let values = components.map((component: any) => component.value);
    //   deviceId = Fingerprint2.x64hash128(values.join(""), 31);;
    //   console.log("bypass sw.js");
    // } else {
    //   console.log(" getFingerPrintAndSubscription ");
    //   let FPAndUS = await getFingerPrintAndSubscription();
    //   console.log(" getFingerPrintAndSubscription FPAndUS: ", FPAndUS);
    //   deviceId = FPAndUS[0];
    //   userSubscription = FPAndUS[1];
    //   console.log(" sw.js");
    // }

    console.log("called getFingerPrintAndSubscription Done");

    let deviceName = `${getBrowserName()} on ${getOSName()}`;
    let deviceToken = userSubscription ? JSON.stringify(userSubscription) : "";

    const login = await RequestToken.post({
      data: {
        username: state.AppInitializeSequence.username,
        password: state.AppInitializeSequence.password,
        device_id: deviceId,
        device_type: "webpush",
        device_name: deviceName,
        device_token: deviceToken,
        application: CONFIG.APP_NAME,
      },
      apiToken: controller.apiToken,
    });
    // if (login[1]) return console.log(login[1]);
    if (login) {
      console.log("login", login);
      controller.setState({
        loadingLogin: false,
      });

      // * Response: Error หรือ login แล้วไม่ได้ token
      const isError = login[1] || !login[0]?.token;
      console.log("isError: ", isError);

      if (isError) {
        console.log(login[1]);
        controller.setState({
          errorMessage:
            login[2]?.response?.status >= 500
              ? { server: "Internal Server 500" }
              : login[1] || { request_token_errors: ["CORS errors"] },
        });
        return;
      }

      controller.handleEvent({ message: "HandleLoginSuccess", params: { login: { ...login[0], type: params.type } } });
    }
  }
};
export const GetUserProfileDetail: Handler = async (controller) => {
  const [userEmployee, userDetail] = await Promise.all([
    UserEmployeeDetailAPIView.retrieve({
      apiToken: controller.apiToken,
      pk: controller.data.user,
      extra: { division: controller.data.division },
    }),
    UserDetailAPIView.retrieve({
      apiToken: controller.apiToken,
      pk: controller.data.user,
      extra: { division: controller.data.division },
    }),
  ]);

  return {
    ...userEmployee[0],
    ...userDetail[0],
    employee: userEmployee[0]?.id,
  };
};

export const GetUserInfo: Handler = async (controller, params) => {
  const state = controller.getState();
  if (!state.AppInitializeSequence) return;

  const [
    divisions,
    preFlight,
    providerDoctor,
    providerEmployee,
    roleList,
    screenRes,
    divisionHasUser,
    userPosition,
    myPermission,
    currentDoctor,
    divisionHasUserForOther,
    constanceConfig,
    userProfile,
    menuHasVideo,
    officialAccount
  ] = await Promise.all([
    DivisionList.list({
      params: { limit: 9999 },
      apiToken: controller.apiToken,
    }),
    preflightM.get({
      apiToken: controller.apiToken,
    }),
    GetProviderInfo.get({
      user_id: controller.data.user,
      params: { type: "doctor" },
      apiToken: controller.apiToken,
    }),
    GetProviderInfo.get({
      user_id: controller.data.user,
      apiToken: controller.apiToken,
    }),
    RoleList.list({
      params: {},
      apiToken: controller.apiToken,
    }),
    ScreenListView.list({
      apiToken: controller.apiToken,
      params: { limit: 9999 },
    }),
    DivisionHasUserList.list({
      params: {},
      apiToken: controller.apiToken,
    }),
    MyPositionDetail.retrieve({
      apiToken: controller.apiToken,
    }),
    MyPermissionView.list({
      apiToken: controller.apiToken,
    }),
    GetCurrentDoctorView.get({
      apiToken: controller.apiToken,
    }),
    DivisionHasUserListForOtherUser.get({
      pk: Cookies.get("user_id"),
      apiToken: controller.apiToken,
      extra: {
        division: controller.data.division,
      },
    }),
    ConstanceView.get({
      apiToken: controller.apiToken,
      params: {
        list: ["BIL_AUTO_RUN_RECEIPT"].join(","),
      },
    }),
    GetUserProfileDetail(controller, params),
    MenuHasVideoListView.list({
      apiToken: controller.apiToken,
    }),
    OfficialAccountDetailWithDivision.get({
      apiToken: controller.apiToken,
      division_id: controller.data.division,
    }),
  ]);

  const divisionHasUserForOtherList = divisionHasUserForOther?.[0]?.items?.map(
    (item: any) => item.division.id
  );

  // นำ Screen Item inject กลับไปที่ CONFIG
  CONFIG.SCREEN_ITEM = screenRes?.[0]?.items;

  // Handle division-related data and state ========================================
  const {
    adminMenuDivisions,
    allDivisionList,
    divisionDict,
    divisionHasUserItems,
    divisionItems,
    divisionList,
    divisionOptions,
  } = prepareDivisionHasUser(
    divisionHasUser[0]?.items || [],
    divisions[0]?.items,
    userProfile?.is_superuser
  );

  const filteredMenuHasVideos = (menuHasVideo[0]?.items || []).filter((item: any) => item.active);
  const groupedMap = new Map<string, any>();

  for (const item of filteredMenuHasVideos) {
    const existing = groupedMap.get(item.menu) || [];

    groupedMap.set(item.menu, [...existing, item]);
  }

  console.log('GetUserInfo divisionHasUserItems: ', divisionHasUserItems);

  if (divisionHasUserItems?.length === 0 && currentDoctor?.[0]?.doctor && !state.loginWithSocial) {
    alert("This Doctor not HAVE any active division to perform")
  }

  const allDivisionDict = Object.fromEntries(allDivisionList.map((item: any) => [item.id, item]));
  const filterDivision = divisionList?.flatMap((item: any) =>
    divisionHasUserForOtherList?.includes(item.id)
      ? [{ ...item, useRights: divisionDict[item.id]?.useRights || [] }]
      : []
  );

  console.log("GetUserInfo divisionDict: ", divisionDict);

  // Set selectedDivision to in controller.data (from cookies) or first in the list
  const selectedDivision =
    (controller.data.division &&
      controller.data.division !== 0 &&
      divisionDict[controller.data.division]) ||
    divisionItems[0] ||
    null;

  const divisionType = divisionDict?.[selectedDivision?.id || 0]?.type_label || null;
  console.log("ประเภทหน่วยงาน:", divisionType || "ไม่ทราบ");

  const [divisionDetail, deviceList] = await Promise.all([
    DivisionDetail.retrieve({
      pk: selectedDivision?.id,
      apiToken: controller.apiToken,
    }),
    DeviceList.list({
      params: { division: selectedDivision?.id || 0 },
      apiToken: controller.apiToken,
    }),
  ]);

  const deviceItems: any[] = deviceList[0]?.items || [];
  const deviceOptions = deviceItems.map((item: any) => ({
    key: item.id,
    value: item.id,
    text: item.computer_name,
  }));

  const deviceDict = Object.fromEntries(deviceItems.map((item: any) => [item.id, item]));

  // Set selectedDevice to in controller.data (from cookies) or first in the list
  const selectedDevice =
    (controller.data.device &&
      controller.data.device !== 0 &&
      deviceDict[controller.data.device]) ||
    deviceItems[0] ||
    null;

  // Set data and state ============================================================
  controller.data = {
    ...controller.data,
    provider: providerDoctor?.[0]?.id || null,
    division: selectedDivision?.id || 0,
    divisionHasUser: divisionHasUserItems,
    divisionDict: divisionDict,
    allDivisionList,
    allDivisionDict,
    allDivisionGroup: divisionList,
    divisionDetail: !divisionDetail[1] ? divisionDetail[0] : {},
    device: selectedDevice?.id || 0,
    deviceDict: deviceDict,
    userProfile,
    constanceConfig: constanceConfig[0]?.result || {},
  };

  Cookies.set("division_id", controller.data.division!.toString());
  Cookies.set("device_id", controller.data.device!.toString());

  console.log("GetUserInfo CU divisionList: filterDivision", filterDivision);
  console.log("GetUserInfo HISV3 (NOT USE) divisionList: divisionItems", divisionItems);

  console.log(
    "GetUserInfo CU selectedDivision: selectedDivision",
    filterDivision?.find((div: any) => div.id === controller.data.division)
  );
  console.log("GetUserInfo HISV3 (NOT USE) selectedDivision: selectedDivision", selectedDivision);

  controller.setState({
    django: {
      ...preFlight[0],
      division: selectedDivision?.id || 0,
    },
    isDoctor: preFlight?.user?.role_types?.includes(CONSTANT.USER_ROLE_TYPE.DOCTOR) ? true : false,
    isNurse: preFlight?.user?.role_types?.includes(CONSTANT.USER_ROLE_TYPE.REGISTERED_NURSE)
      ? true
      : false,
    providerInfo: {
      ...providerDoctor[0],
      provider_id: providerDoctor[0]?.id,
      first_name: providerDoctor[0]?.doctor_info?.first_name,
      last_name: providerDoctor[0]?.doctor_info?.last_name,
      pre_name: providerDoctor[0]?.doctor_info?.pre_name,
      code: providerDoctor[0]?.doctor_info?.code,
    },
    providerEmployeeInfo: providerEmployee[0],
    userRoleList: roleList[0] ? roleList[0]?.items || [] : [],
    divisionType: divisionType,
    selectedTabIndex: getSideMenuIndex(
      params.defaultSideMenu ? { tab: params.defaultSideMenu } : { divisionType },
    ),
    divisionList: filterDivision,
    divisionOptions: divisionOptions,
    divisionHasUserItems: divisionHasUserItems,
    selectedDivision: selectedDivision,
    deviceOptions: deviceOptions,
    selectedDevice: selectedDevice,
    loggedin: true,
    currentDoctor: currentDoctor?.[0]?.doctor,
    userPosition: userPosition?.[0],
    myPermission: myPermission?.[0],
    userId: preFlight[0]?.user?.id?.toString(),
    userProfile,
    adminMenuDivisions,
    ...(state.loginWithSocial && !divisionDetail[0] && { mode: "user" }),
    menuHasVideos: Object.fromEntries(groupedMap),
    officialAccountDetail: officialAccount[0] || {},
  });

  // Login Firebase --------------------------------------------------------
  controller.setState(
    {
      AppInitializeSequence: {
        ...state.AppInitializeSequence,
        sequenceIndex: "LoginFirebase",
      },
    },
    () => controller.handleEvent({ message: "RunSequence", params: params })
  );
};

export const LoginFirebaseWithCustomToken: Handler = async (controller, params) => {
  console.log("LoginFirebaseWithCustomToken : signInWithCustomToken ");
  let retryWithFastAPI = false;
  // FUNCTION
  if (CONFIG.OFFLINE) {
    return LoginFirebaseWithFastAPI(controller, {});
  }

  try {
    // Build the callable (modular)
    if (controller.functions && controller.auth) {
      const createTokenFromUser = httpsCallable<string, string>(
        controller.functions, // must be from getFunctions(app[, region])
        "createTokenFromUser"
      );

      // Call it with your userId

      const { data: customToken } = await createTokenFromUser(String(params?.userId ?? "", params?.permit));

      // Sign in with the returned custom token (modular)
      const cred = await signInWithCustomToken(controller.auth, customToken); // controller.auth from getAuth(app)

      console.log("LoginFirebaseWithCustomToken signInWithCustomToken res:", cred);

      const idToken = await cred.user.getIdToken(); // returns a Promise<string>
      console.log("LoginFirebaseWithCustomToken user.getIdToken():", idToken);

      // optional: controller.setState({ loggedin: true, firebaseToken: idToken });
    }
  } catch (error) {
    console.error("LoginFirebaseWithCustomToken error:", error);
    // Fallback
    LoginFirebaseWithFastAPI(controller, {});
  }
};

export const LoginFirebaseWithFastAPI: Handler = async (controller, params) => {
  const FAST_API = `${CONFIG.FAST_API}`;
  axios
    .post(
      `${FAST_API}/api/login/get-firebase-token`,
      {},
      { headers: { Authorization: `Token ${controller.apiToken}` } }
    )
    .then((result: any) => {
      console.log("result: ", result);
      controller.app
        .auth()
        .signInWithCustomToken(result.data.token)
        .then(async (res: any) => {
          console.log("LoginFirebaseWithCustomToken signInWithCustomToken res: ", res);
          console.log(
            "LoginFirebaseWithCustomToken signInWithCustomToken res.user.getIdToken();: ",
            res.user.getIdToken()
          );
          // Test login with firebase id token
          // const firebase_id_token = await res.user.getIdToken();
          // axios.post(
          //   `${FAST_API}/api/login/get-firebase-user`, {},
          //   { headers: { "Authorization": `Token ${firebase_id_token}`}}
          // ).then((res: any) => {
          //     console.log("uid", res.data);
          // })
          // .catch((err: any) => {
          //   console.log(err);
          // });
        })
        .catch(function (error: any) {
          console.error("LoginFirebaseWithCustomToken error: ", error);
          console.log(error);
        });
    })
    .catch((error: any) => {
      console.log(error);
    });
};

export const LoginFirebase: Handler = async (controller, params) => {
  const state = controller.getState();
  console.log("LoginFirebase check controller: ", controller);

  const onFirebaseAuthStateChanged = async (user: any) => {
    if (!user) {
      console.log("User is signed out");
      const apiToken = controller.apiToken;
      const userId = controller.data.user;
      const permit = controller.data.permit || "";

      if (apiToken && userId) {
        LoginFirebaseWithCustomToken(controller, { userId: userId, permit: permit });
      }
    } else {
      console.log("User is signed in, ", user.uid);
    }
  };

  // LoginFirebaseWithCustomToken(controller, controller.data.user );
  if (controller.auth) {
    onAuthStateChanged(controller.auth, onFirebaseAuthStateChanged);
  }

  // Finishing up --------------------------------------------------------
  controller.setState(
    {
      AppInitializeSequence: {
        ...state.AppInitializeSequence,
        sequenceIndex: "Finish",
      },
    },
    () => controller.handleEvent({ message: "RunSequence", params: params })
  );
};

export const Finish: Handler = async (controller, params) => {
  const state = controller.getState();
  if (!state.AppInitializeSequence) return;

  // Finish the sequence
  controller.setState({
    AppInitializeSequence: null,
  });
};

export const prepareDivisionHasUser = (
  divisionHasUserItems: Record<string, any>[],
  allDivisionList: any[] = [],
  isSuperUser = false
) => {
  const allDivisionIds = new Set(allDivisionList.map((item) => item.id as number));
  const divisionList = groupDivisionFamily(null, allDivisionList);

  // Filter active divisions only
  const filteredActiveItems = divisionHasUserItems
    .filter((item) => allDivisionIds.has(item.division?.id || ""))
    .filter((item) => {
      let extra = {};

      try {
        extra = JSON.parse(item.extra);
      } catch (error) {
        console.log("e", error);
      }

      return (extra as any).is_Active;
    });

  // division items with useRights (remove duplicates)
  const divisionItems: any[] = [];
  const seenDivisionIds = new Set<number>();

  for (const item of filteredActiveItems) {
    if (!seenDivisionIds.has(item.division.id)) {
      let extraJSON: any = {};

      try {
        extraJSON = JSON.parse(item.extra);
      } catch (error) {
        console.log("e", error);
      }

      divisionItems.push({
        ...item.division,
        useRights: extraJSON?.useRights || [],
      });

      seenDivisionIds.add(item.division.id);
    }
  }

  // Format with full division info for admin menu
  const formattedDivisionHasUserItems = filteredActiveItems.map((item) => {
    const findDivision = divisionList.find((div) => div.id === item.division.id);

    return { ...item, division: findDivision || item };
  });

  // Create division options for dropdown with optional create OA
  const divisionOptions = divisionItems
    .map((item: any) => ({
      ...item,
      text: item.name,
      value: item.id,
    }))
    .concat(
      CONFIG.CREATE_OFFICIAL_ACCOUNT
        ? {
            id: "create_oa",
            code: "create_oa",
            name: "+ สร้าง Official Account",
            text: "+ สร้าง Official Account",
            value: "create_oa",
          }
        : []
    );

  const divisionDict = Object.fromEntries(divisionItems.map((item: any) => [item.id, item]));

  // Create admin menu divisions
  const adminMenuDivisions = formatAdminMenuDivisions(formattedDivisionHasUserItems, isSuperUser);

  return {
    adminMenuDivisions,
    allDivisionIds,
    allDivisionList,
    divisionDict,
    divisionHasUserItems: filteredActiveItems,
    divisionItems,
    divisionList,
    divisionOptions,
    formattedDivisionHasUserItems,
  };
};

const generateMenuData = (
  items: { adminMenuList: string[]; division: Record<string, any> }[],
  menu: AdminMenuListKey,
  isSuperUser: boolean
) => {
  // ถ้าเป็น super user จะได้ทุกหน่วยงาน ถ้าไม่ใช่จะได้เฉพาะที่มีเมนูนี้
  const divisionsWithMenu = items
    .filter((item) => isSuperUser || item.adminMenuList.includes(menu))
    .map((item) => item.division);

  const seenIds = new Set();
  const uniqueDivisions = divisionsWithMenu.filter((item) =>
    seenIds.has(item.id) ? false : seenIds.add(item.id)
  );

  const allTabs = Array.isArray(ADMIN_MENU_LIST[menu]) ? [...ADMIN_MENU_LIST[menu]] : [];
  // super user จะเห็นทุก tab, ผู้ใช้ทั่วไปจะเห็นเฉพาะที่มีสิทธิ์
  const allAvailableTabs = isSuperUser
    ? allTabs
    : [
        ...new Set(
          items
            .filter((item) => item.adminMenuList.includes(menu))
            .flatMap((item) => allTabs.filter((tab) => item.adminMenuList.includes(tab)))
        ),
      ];

  return { allTabs: allAvailableTabs, divisions: mapOptions(uniqueDivisions) };
};

const formatAdminMenuDivisions = (
  divisionHasUserItems: Record<string, any>[],
  isSuperUser = false
): AdminMenuDivisionType => {
  const formattedItems = divisionHasUserItems.map((item) => {
    const adminMenuList = (JSON.parse(item.extra).adminMenuList || []) as string[];

    return {
      ...item,
      adminMenuList: adminMenuList.filter((menu) => !CONFIG.V3_HIDDEN_TAB_LIST.includes(menu)),
      division: item.division as Record<string, any>,
    };
  });

  // super user จะเห็นทุกเมนู, ผู้ใช้ทั่วไปจะเห็นเฉพาะที่มีสิทธิ์
  const allMenus = (
    isSuperUser
      ? (Object.keys(ADMIN_MENU_LIST) as AdminMenuListKey[]).filter(
          (menu) => !CONFIG.V3_HIDDEN_TAB_LIST.includes(menu)
        )
      : [
          ...new Set(
            formattedItems.flatMap((item) =>
              item.adminMenuList.filter((menu): menu is AdminMenuListKey => menu in ADMIN_MENU_LIST)
            )
          ),
        ]
  );

  const menuData = Object.fromEntries(
    allMenus.map((menu) => [menu, generateMenuData(formattedItems, menu, isSuperUser)])
  );

  const divisionMenuMap: AdminMenuDivisionType = {
    all: Object.fromEntries(
      allMenus.map((menu) => {
        const ids = menuData[menu].divisions.map(
          (div) => [div.value, div.value] as [number, number]
        );

        return [
          menu,
          {
            divisions: menuData[menu].divisions,
            ids: Object.fromEntries(ids),
            tabs: menuData[menu].allTabs,
          },
        ];
      })
    ),
  };

  for (const { adminMenuList, division } of formattedItems) {
    // กำหนดเมนูที่หน่วยงานนี้สามารถเข้าถึงได้
    const filteredMenus = isSuperUser
      ? allMenus
      : adminMenuList.filter((menu): menu is AdminMenuListKey => menu in ADMIN_MENU_LIST);

    divisionMenuMap[division.id] = Object.fromEntries(
      filteredMenus.map((menu) => {
        const allTabs = Array.isArray(ADMIN_MENU_LIST[menu]) ? [...ADMIN_MENU_LIST[menu]] : [];
        // กำหนด tabs ที่หน่วยงานนี้สามารถเข้าถึงได้
        const tabs = isSuperUser ? allTabs : allTabs.filter((tab) => adminMenuList.includes(tab));

        return [menu, { divisions: menuData[menu].divisions, tabs }];
      })
    );
  }

  return divisionMenuMap;
};

export const groupDivisionFamily: (parent: number | null, items: any[]) => any[] = (parent, items) => {
  if (!parent) {
    return items.map((item: any) => ({
      ...item,
      children: groupDivisionFamily(item.id, items),
    }));
  }
  return items
    .filter((item: any) => item.parent === parent)
    .map((item: any) => ({
      ...item,
      children: groupDivisionFamily(item.id, items),
    }));
};

// หา hierarchy chain จาก child ไปยัง root
export const getDivisionHierarchy = (
  targetId: number | string | null = null,
  flatData: any[] = []
): Record<string, any>[] => {
  const itemMap = new Map();

  for (const item of flatData) {
    itemMap.set(item.id, item);
  }

  const result = [];

  let currentId = targetId;

  while (currentId) {
    const currentItem = itemMap.get(currentId);

    if (!currentItem) {
      break;
    }

    result.unshift(currentItem);
    currentId = currentItem.parent; // ใช้ parent property
  }

  return result;
};

export const getDivisionDescendants = (
  parentId: number | null = null,
  flatData: any[]
): Record<string, any>[] => {
  const result: any[] = [];

  if (!parentId) {
    return [];
  }

  const findChildren = (currentParentId: number) => {
    const children = flatData.filter((item) => item.parent === currentParentId);

    for (const child of children) {
      result.push(child);
      findChildren(child.id); // recursive หาลูกของลูก
    }
  };

  findChildren(parentId);

  return result;
};

export const getDivisionParentName = (
  targetId: number | string | null = null,
  allDivisionGroup: any[] = [],
  shouldReverse = false
) => {
  if (!targetId) {
    return "";
  }

  const divisions = getDivisionHierarchy(targetId, allDivisionGroup);

  const processedDivisions = shouldReverse ? [...divisions].reverse() : divisions;

  return processedDivisions
    .map((div) => div.name as string)
    .filter(Boolean)
    .join(", ");
};